import React from 'react';
import { SpRelic, SpRelicDocument } from '../domain/relic';
import { useCollection } from '../hooks/use-collection';
import PureRelics from '../ui/PureRelics';


function Relics() {
  const { loading, documents, collection } = useCollection<SpRelicDocument>();
  const addItem = (relic: SpRelic) => {
    collection?.add(relic);
  }
  const deleteItem = (id: string) => {
    collection?.doc(id).delete();
  }
  return <PureRelics loading={loading} relics={documents} addRelic={addItem} deleteRelic={deleteItem} />
}

export default Relics;
